import { MOCK_PULSE } from "@/lib/mockData";
import { TrendingUp, UserCheck, Sparkles } from "lucide-react";

const PulseWidget = () => {
  const p = MOCK_PULSE;
  return (
    <div className="brutal-card p-5 bg-[#0A0A0A] text-white" data-testid="pulse-widget">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <span className="relative flex h-3 w-3">
            <span className="live-ping absolute inline-flex h-full w-full rounded-full bg-[#FF6A2C] opacity-75" />
            <span className="relative inline-flex rounded-full h-3 w-3 bg-[#FF6A2C]" />
          </span>
          <span className="label-mono">Activity Pulse</span>
        </div>
        <span className="text-xs text-[#999] font-mono">live</span>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <PulseStat icon={UserCheck} value={p.recent_joins_5min} label="Joins / 5m" />
        <PulseStat icon={Sparkles} value={p.new_activities_10min} label="New / 10m" />
        <PulseStat icon={TrendingUp} value={p.spots_opened} label="Spots open" />
      </div>

      <div className="mt-4 pt-4 border-t border-white/15 flex items-center justify-between text-sm">
        <span className="text-[#A0A0A0]">{p.active_people} active people</span>
        <span className="text-[#A0A0A0]">{p.nearby_count_10km} within 10km</span>
      </div>
    </div>
  );
};

const PulseStat = ({ icon: Icon, value, label }) => (
  <div className="bg-white/5 rounded-lg p-3 border border-white/10">
    <Icon className="w-4 h-4 text-[#FFCC00] mb-1" />
    <div className="font-heading font-black text-2xl leading-none">{value}</div>
    <div className="label-mono text-[#A0A0A0] mt-1">{label}</div>
  </div>
);

export default PulseWidget;
